if (!customElements.get('ecom-product')) {
  customElements.define('ecom-product', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.form = this.querySelector('form[action*="cart/add"]');
      const nativeVariants = this.querySelector('[data-native-variants]');
      const variantButtons = this.querySelector('.ecom-variants');
      if (nativeVariants && variantButtons) { nativeVariants.hidden = true; variantButtons.hidden = false; }
      this.addEventListener('change', event => {
        const input = event.target;
        if (!input.matches('[data-variant-option]')) return;
        const variantId = this.form.querySelector('[name="id"]');
        variantId.value = input.value;
        variantId.dispatchEvent(new Event('change', {bubbles:true}));
        this.querySelector('shopify-payment-terms')?.setAttribute('variant-id', input.value);
        this.querySelectorAll('[data-price]:not(input)').forEach(node => node.textContent = input.dataset.price);
        this.querySelectorAll('[data-pair-before]').forEach(node => node.textContent = input.dataset.price);
        this.querySelectorAll('[data-pair-after]').forEach(node => node.textContent = input.dataset.pairPrice);
        this.querySelectorAll('[data-selected]').forEach(node => node.textContent = input.dataset.title);
        this.resetButtons();
        const quantity = this.querySelector('input[name="quantity"]');
        quantity.min = input.dataset.min || 1;
        quantity.step = input.dataset.step || 1;
        if (input.dataset.max) quantity.max = input.dataset.max; else quantity.removeAttribute('max');
        quantity.value = quantity.min;
        const url = new URL(location.href);
        url.searchParams.set('variant', input.value);
        history.replaceState({}, '', url);
        if(input.dataset.media){const media=document.getElementById(`EcomMedia-${this.dataset.section}-${input.dataset.media}`),gallery=this.querySelector('.ecom-gallery');if(media&&gallery&&gallery.scrollWidth>gallery.clientWidth)gallery.scrollTo({left:media.offsetLeft-gallery.offsetLeft,behavior:'auto'});}
      });
      this.querySelectorAll('[data-pair-enhance]').forEach(node => node.hidden = false);
      this.querySelectorAll('[data-zoom]').forEach(button => button.addEventListener('click', () => {
        const img = this.querySelector('[data-zoom-image]');
        img.src = button.dataset.zoom;
        img.alt = button.querySelector('img').alt;
        this.querySelector('[data-zoom-dialog]').showModal();
      }));
      const tables = this.querySelectorAll('[data-description] table');
      const sizeButton = this.querySelector('[data-size-guide]');
      const sizeContent = this.querySelector('[data-size-content]');
      if (sizeContent && !sizeContent.querySelector('table')) tables.forEach(table => sizeContent.append(table.cloneNode(true)));
      if (sizeContent?.querySelector('table') && sizeButton) {
        sizeButton.hidden = false;
        sizeButton.addEventListener('click', () => this.querySelector('[data-size-dialog]').showModal());
      }
      this.querySelectorAll('dialog').forEach(dialog => dialog.addEventListener('click',event => {if(event.target===dialog){const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)dialog.close();}}));
      if (this.form) this.form.addEventListener('submit', event => this.addToBag(event));
      const button = this.querySelector('.ecom-add');
      if (button && 'IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => this.querySelector('.ecom-sticky')?.classList.toggle('is-visible', !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0));
        this.observer.observe(button);
      }
    }
    resetButtons() {
      const selected = this.querySelector('[data-variant-option]:checked') || this.querySelector('[name="id"]');
      this.querySelectorAll('[data-submit]').forEach(button => {
        button.disabled = this.busy || selected?.dataset.available === 'false';
        button.textContent = this.busy ? this.dataset.addingLabel : selected?.dataset.available === 'false' ? this.dataset.soldLabel : this.dataset.addLabel;
      });
    }
    async addToBag(event) {
      if (!window.fetch || !window.FormData) return;
      event.preventDefault();
      if (this.busy) return;
      this.busy = true;
      this.resetButtons();
      const error = this.querySelector('[data-add-error]');
      error.hidden = true;
      this.form.setAttribute('aria-busy','true');
      try {
        const submission = new FormData(this.form);
        const submittedQuantity = Number(submission.get('quantity') ?? 1);
        let submittedPrice = this.querySelector('[data-price]:not(input)')?.textContent || '';
        const result = await fetch(this.dataset.addUrl,{method:'POST',body:submission,headers:{Accept:'application/json'}});
        const item = await result.json();
        if (!result.ok) throw new Error(typeof item.description === 'string' ? item.description : this.dataset.errorLabel);
        const finalPrice = [item.final_price, item.price].find(value => typeof value === 'number' && Number.isFinite(value) && value >= 0);
        if (finalPrice !== undefined && this.dataset.currency) {
          try { submittedPrice = new Intl.NumberFormat(document.documentElement.lang || undefined, {style:'currency', currency:this.dataset.currency}).format(finalPrice / 100); } catch {}
        }
        this.querySelector('[data-added-detail]').textContent = `${item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title+' · ' : ''}${submittedQuantity} × ${submittedPrice}`;
        this.querySelector('[data-added-dialog]').showModal();
        window.dispatchEvent(new Event('ecom:cart-updated'));
        try {
          const countResponse = await fetch(this.dataset.cartUrl.split('?')[0]+'.js',{headers:{Accept:'application/json'}});
          if(countResponse.ok){const cart=await countResponse.json();if(Number.isSafeInteger(cart?.item_count)&&cart.item_count>=0)document.querySelectorAll('[data-cart-count]').forEach(el=>el.textContent=`(${cart.item_count})`);}
        } catch {}
      } catch (failure) {error.textContent=failure.message || this.dataset.errorLabel;error.hidden=false;}
      finally {this.busy=false;this.form.removeAttribute('aria-busy');this.resetButtons();}
    }
    disconnectedCallback() {this.observer?.disconnect();}
  });
}
